export const environment = {
    production: false,
    test: true,
    time: new Date().getTime(),
    titleAppend: ' - ACC - Dirk',
    apiEndpoint: 'https://dirk-acc.dvds.nl/api/',
    feEndpoint: 'https://planning-acc.dvds.nl/',
    wsEndpoint: 'wss://dirk-acc.dvds.nl/websocket/',
};
